module.exports = __webpack_public_path__ + "img/DAVID_CANNON_20-rs.b51257e2.jpg";